import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import BankManagement from './LevelManagement';
import LevelManagement from './LevelManagement';


const LevelManagementLayout: RouteObject[] = [
  {
    path: '/',
    element: (
      <LevelManagement />
    ),
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const LevelManagementRoutes = () => useRoutes(LevelManagementLayout);
export default LevelManagementRoutes;
